<template>
  <AEMissionComponent
    :extra="extra"
    :can-cancel-shifts="canCancelShifts"
    @cancel-shifts="cancelShiftsDialog"
    @open-recruitment-recap="openRecruitmentRecap"
  />
</template>

<script>
  import { RecruitmentCandidatesService } from "@core/services";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { ETAB_ROUTES } from "@etab/config";
  import {
    ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL,
    ACTION_RECRUITMENT_GET,
    GETTER_EXTRA_GET_CURRENT,
    GETTER_RECRUITMENT_GET_CURRENT,
  } from "@etab/stores/types";
  import { useExtraStore } from "@etab/stores/extra";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { useDashboardStore } from "@etab/stores/dashboard";
  import { mapStores } from "pinia";

  import AEMissionComponent from "@etab/components/extra/AEMission.component.vue";

  export default {
    components: {
      AEMissionComponent,
    },
    computed: {
      ...mapStores(useExtraStore, useRecruitmentStore, useDashboardStore),
      demandId() {
        return this.$route.params.demandId;
      },
      demandType() {
        return this.$route.params.demandType;
      },
      candidateId() {
        return this.$route.params.candidateId;
      },
      extra() {
        return this.extraStore[GETTER_EXTRA_GET_CURRENT];
      },
      recruitment() {
        return this.recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
      },
      canCancelShifts() {
        // RG: can cancel as long as the first shift didn't start and extra didn't cancel already
        return !this.extra.hasFirstShiftStarted() && !this.extra.isCanceled() && !this.extra.isIgnored();
      },
    },
    methods: {
      cancelShiftsDialog({ extra }) {
        this.$q
          .dialog({
            title: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@TITLE", { name: extra.getIdentity().firstname }),
            message: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@MESSAGE"),
            ok: {
              label: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@CONFIRM"),
              color: "secondary",
            },
            cancel: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@CLOSE"),
          })
          .onOk(() => this.cancelShifts({ extra }));
      },
      async cancelShifts({ extra }) {
        try {
          this.$_startGlobalLoading();
          const demandId = this.demandId;
          const demandType = this.demandType;
          const candidateId = this.candidateId;

          await RecruitmentCandidatesService.cancelFutureShifts({ demandId, extraId: candidateId });
          // refresh demand in order to remove the canceled candidate
          await this.recruitmentStore[ACTION_RECRUITMENT_GET]({ demandId, demandType });
          // go to applied candidates page, replace in order to not go back to profile
          this.$router.replace({
            name: ETAB_ROUTES.dashboard.recruitment.temporary.detail.applied.name,
            params: { demandId, demandType },
          });
        } catch (error) {
          NotificationsManager.contactEtabSupport();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      openRecruitmentRecap() {
        this.dashboardStore[ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL]({ recap: this.recruitment });
      },
    },
  };
</script>
